import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dynamic",
  "use": "icon-dynamic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-dynamic\"><defs><style type=\"text/css\"></style></defs><path d=\"M661.3 384l-234.7 42.7L384 661.3l234.7-42.7L661.3 384zM522.7 576c-29.5 0-53.3-23.9-53.3-53.3 0-29.5 23.9-53.3 53.3-53.3 29.5 0 53.3 23.9 53.3 53.3S552.1 576 522.7 576zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m166.3 614.3l-379.6 68.4L367 367l379.6-68.4-68.3 379.7z\" p-id=\"15093\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol